import $ from 'jquery'
$(window).on('load', () => {
  const carouselImage = $('.swiper-box a .images img')
  const carousel = $('.m_areas .swiper-box')

  carousel.each(() => {
    const carouselCount = carouselImage.length
    let resultHeight = 0

    for (let count = 0; count < carouselCount; count += 1) {
      const imageHeight = carouselImage.eq(count).height()

      if (count > 0) {
        const prevImageHeight = carouselImage.eq(count - 1).height()

        if (imageHeight > prevImageHeight) {
          resultHeight = imageHeight
        }
      }
      $('.swiper-box a .images').css('height', resultHeight)
    }
  })
})
